'use strict';

var elements = document.querySelectorAll('.element');

elements.forEach(function (element) {
  var btn = element.querySelector('.question button');
  var question = element.querySelector('.question');
  var icon = element.querySelector('.question button i');
  var answer = element.lastElementChild;
  var answers = document.querySelectorAll('.element .answer');

  question.addEventListener('click', function () {
    answers.forEach(function (ans) {
      // let ansIcon = ans.parentElement.querySelector('button i');
      if (answer === ans) {
        ans.classList.toggle('is-hidden');
        // ansIcon.className = 'fas fa-plus-circle';
      }
    });

    // answer.classList.toggle('is-hidden');
  });
});

document.querySelectorAll('.header__nav-item').forEach(function(el) {
  var currentPage = location.origin + location.pathname
  if (el.href === currentPage) {
      el.classList.add('active')
  }
})


// WEBPACK FOOTER //
// ./source/assets/js/functional.js